import { render, staticRenderFns } from "./labelManage.vue?vue&type=template&id=1bf2f679&scoped=true"
import script from "./labelManage.vue?vue&type=script&lang=js"
export * from "./labelManage.vue?vue&type=script&lang=js"
import style0 from "./labelManage.vue?vue&type=style&index=0&id=1bf2f679&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2f679",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf2f679')) {
      api.createRecord('1bf2f679', component.options)
    } else {
      api.reload('1bf2f679', component.options)
    }
    module.hot.accept("./labelManage.vue?vue&type=template&id=1bf2f679&scoped=true", function () {
      api.rerender('1bf2f679', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LabelGroup/labelManage.vue"
export default component.exports